export default __webpack_public_path__ + "static/media/721_LOGO_para3D.acc2267c.svg";